import React, {Component} from 'react';
import Header from './header'
import Footer from './footer'
import define from './define';
import users from './store/user'
import {Link, browserHistory} from 'react-router'
import './css/topVisitor1.css';
import firebase from 'firebase'
import {onLogin, TrustdockResultregister} from './firebase'
import ToggleDisplay from 'react-toggle-display';
import htmlspecialchars from 'htmlspecialchars';
import request from 'request-promise';
import {IsLoading} from './loading';

import './css/toast_custom.css'
import './css/demo.css';
import Toast from './components/toast'

//ユーザランク取得処理
//連携サービス取得処理
import {
  getUserRank,
  getUserService
} from './functions/getUserRank'

import {
  getPartnerList
} from './functions/getPartnerList'


export default class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      rank:"",
      rank_img:"",
      rank_class:"",
      rank_jp:"",
      rank_class_jp:"",
      rank_chart:"",

      displayName: "",
      photoURL: "",
      canvasImg:"",
      bio:"",
      isMylisence:true,

      accessCounter:null,
         
      uid:"",
      isLogin:false,
      old_uid:'',

      //toast message表示判定
      isToast:false,

      partnerslist:{}
      
    };
    
  }
  
  componentDidMount() {
    this.thisOnlogin()
  }

  thisOnlogin = () => {
    const {
      location
    } = this.props

    if(location.state && location.state.hasOwnProperty('isCertification')) {
      this.setState({isToast:location.state.isCertification})
    }

    var scope = this
    // ログインチェック
    onLogin((isLogin) => {
      scope.setState({isLogin:isLogin})

      // URLにIDが付与されている場合
      let path = window.location.pathname;
      let path_arr = path.split("/");
      var url_uid = "";
      if ("" !== path_arr[2] && null !== path_arr[2] && "undefined" !== typeof path_arr[2]) {
        url_uid = path_arr[2];
      }


      //ユーザー情報取得APIをたたく（非ログインユーザー用）
      let getUserData = (uid) => {
        let xhr = new XMLHttpRequest()
        xhr.onreadystatechange = () => {
          if(xhr.readyState === 4) {
            if(xhr.status === 200) {
              //console.log(xhr.response)
              setUserData(JSON.parse(xhr.response),true)
            }
          }
        }
        xhr.open('POST','/api/getUser')
        xhr.setRequestHeader('Content-Type','application/json')
        xhr.send(JSON.stringify({uid:uid}))
      }

      // ユーザーのプロフィール取得　取得したusersテーブルの情報からtrustdock,ランク情報、連携サービス情報を取得  
      let setUserData = (snapshot,bool) => {
        //console.log(snapshot)
        let snap = typeof snapshot.val === 'function' ? snapshot.val() : snapshot
        // 存在しないユーザー、本登録が済んでいないユーザーではないか
        if (null !== snap) {
          if ("true" === snap.registComplete) {
            scope.setState({displayName: snap.displayName});
            scope.setState({photoURL: snap.updatePhoto ? snap.updatePhoto : "https://graph.facebook.com/" + snap.facebookId + "/picture?width=250&height=250"});
            scope.setState({canvasImg: "data:image/jpeg;base64," + snap.canvasImgURL});
            scope.setState({bio: snap.bio});
            if ("approved" === snap.trustdockResult) {
              scope.setState({id_on: true});
              scope.setState({popup_count: 3});
            //TODO 20180309 レビュー待ち状態のためreuploadの関連する処理を外す
            } else if ("denied" === snap.trustdockResult || "reupload" === snap.trustdockResult) {
            //} else if ("denied" === snap.trustdockResult) {
              scope.setState({id_on: false});
              // ID登録がエラーまたは名前変更して再度ID認証が必要なユーザーでログインユーザーの場合、再アップロードさせる
              if ("" !== url_uid || url_uid === uid) {
                if (isMylisence) {
                  browserHistory.push("/newEdit");
                } else {
                  browserHistory.push("/404");  
                }
              }
            } else {
              // loading
              scope.setState({id_on: false});              
              // 本人認証が済んでいるか確認
              if (users.getMyUser() && users.getMyUser().trustdockId) {
                var options = {
                  url: define.TRUSTDOCK_CONFIG.review_api_url + users.getMyUser().trustdockId,
                  method: 'GET',
                  headers: define.TRUSTDOCK_CONFIG.review_api_headers
                }

                request(options, (err, res, body) => {
                  body = JSON.parse(body)
                  if ("" !== body.review && null !== body.review && "undefined" !== typeof body.review) {
                    if ("approved" === body.review.result || "denied" === body.review.result) {
                      TrustdockResultregister(body.review.result);
                    }
                  }
                });
              }
            }
            //自分のライセンスページだけアクセスカウンタ表示
            if(isMylisence) {
              if(snap.hasOwnProperty('access_counter')) {
                scope.setState({accessCounter:snap.access_counter})
              }
            } else {
              scope.setState({accessCounter:''})              
            }
            
            // ポイントテーブルを取得
            //外部ファイル化20180412
            getUserRank(uid,scope,bool,snap)
            // 各サービス連携データ読み取り
            //外部ファイル化20180413
            getUserService(uid,scope,snap)
            //get partnerlist
            getPartnerList(uid,scope)

          } else {
            // 本登録が済んでいないユーザーの場合
            browserHistory.push("/404");
          }
        } else {
          // 存在しないユーザーの場合
          browserHistory.push("/404");
        }
      }

      // ログインできているか
      var uid = "";
      let isMylisence = true
      if (true === isLogin) {
        uid = users.getMyUser().uid;
        // URLのIDと自分のIDが同じか
        if ("" !== url_uid && url_uid !== uid) {
          uid = url_uid;
          isMylisence = false
        }
        // URLのuid欄が空の場合書き換え
        if ("" === url_uid) {
          //console.log(uid)
          window.history.replaceState(null, null, "/demo");
        }
        scope.setState({uid:uid})

        //他人のライセンスで初回読み込みするとon()が他人のuidから引いたデータを監視するため表示ユーザーがかわるたび監視をoffにしてからあらたに表示するユーザーのuidで監視を再開する
        if(scope.state.old_uid) {
          var oldRef = firebase.database().ref("users/" + scope.state.old_uid + "/");
          oldRef.off('value');
        }
        var userRef = firebase.database().ref("users/" + uid + "/");
        userRef.on('value', setUserData);
        scope.setState({old_uid:uid})

      } else {
        //console.log('NOT_LOGIN')
        // uidの指定がなければログインページに飛ばす
        if ("" === url_uid) {
          browserHistory.push("/lpLogin");
          return
        }
        // ログインできていない場合はURLで指定されたIDの情報を参照
        uid = url_uid;
        isMylisence = false
        //非ログインユーザーはDBに直接アクセス権がないのでAPIを叩く
        getUserData(uid)
      }
      scope.setState({isMylisence:isMylisence})
      // scope.setState({uid:uid})


      //アクセスカウンタ更新
      let setAccessCounter = (uid) => {
        let xhr = new XMLHttpRequest()
        xhr.onreadystatechange = () => {
          if(xhr.readyState === 4) {
            if(xhr.status === 200) {
              //console.log(xhr.response)
              //setUserData(JSON.parse(xhr.response))
              //return 
              
            }
          }
        }

        xhr.open('POST','/api/setAccessCounter')

        xhr.setRequestHeader('Content-Type','application/json')
        //console.log(params)
        xhr.send(JSON.stringify({uid:uid}))
      }
      if(!isMylisence) {
        //console.log(uid)
        setAccessCounter(uid)
      }

    }, false);
  }

  showAccessCounter = () => {
    const {
      accessCounter
    } = this.state
    if(!accessCounter) return
    return (
      <p className="text-center user-access-counter">総アクセス数：{accessCounter}</p>
    )
  }

  isLoading = () => {
    const {
      rank_chart,
      photoURL,
      displayName
    } = this.state
    if(rank_chart && photoURL) {
      return (
        <div className="block-thum clearfix">
          <img alt="" className="user-chart" src={rank_chart} />
          <img alt="" className="user-thum" src={photoURL} />
          <p className="text-center user-name">{htmlspecialchars(displayName)}</p>
          <p className="text-center user-address">Japan</p>
          { this.showAccessCounter() }
        </div>
      )
    } else {
      return IsLoading()
    }
  }


  setPartnerList = () => {
    const {
      partnerslist
    } = this.state
    let result = []
    Object.keys(partnerslist).forEach((k) => {
      result.push(
        <li key={k}>
          <ToggleDisplay>
            <div className="icon-achievement">
              <p className="name-partner">{partnerslist[k].site_name}</p>
              <div className="popup">
                <p className="popup-title">ID: <span className="red">{partnerslist[k].uid}</span></p>
                <div className="line-dashed"></div>
                <p className="popup-title">POINT: <span className="red">{partnerslist[k].point}</span></p>
                <div className="line-dashed"></div>
                <div className="popup-content">
                  <h2 className="title">Comment</h2>
                  <p className="red">{partnerslist[k].comment}</p>
                </div>
              </div>
            </div>
            </ToggleDisplay>
        </li>
      )
    })
    return result
  }


  returnToast = () => {
    const {
      isToast,
    } = this.state
    const {
      location
    } = this.props    
    if(isToast) {
      if(location.state.hasOwnProperty('isCertification')) {
        let callback = () => {
          this.setState({isToast:false})
          browserHistory.replace({
            pathname: '/deno',
            state: {}
          })
        }
        let message = (<div className="toast-success"><p>認証に成功しました。</p></div>)
        return (
          <Toast notifyMessage={message} callback={callback} />
        )
      }
    }
  }

render(){
  return (
    <div>
      {this.returnToast()}
      <div id="wrapper">
      <div id="" className="wrapper-lp wrapper-topVitor1">
    
        <Header/>
        <canvas id="canvas">Canvas is not supported in your browser.</canvas>
        <div className="webWrap">
          <div className="wrapCover">
            <div className="wrapCover__contentBlock clearfix">
              <div className="content-top">
                <div className="block-rank">
                  <img alt="" className="icon-rank" src={this.state.rank_img} />
                  <div className="font-rank">

                    <p className={this.state.rank_class}>{this.state.rank}</p>
                    <p className={this.state.rank_class_jp}>{this.state.rank_jp}</p>
                  </div>
                </div>
                { this.isLoading() }
                <div className="line-dashed"></div>
                <div className="wrapPartner">
                  <h2 className="subtitle-en">List Partners</h2>
                  <ul className="partners">
                    { this.setPartnerList() }
                  </ul>
                </div>
              </div>
            </div>
            <ToggleDisplay if={!this.state.isLogin}>
            <Link to=""><img alt="" className="footer-banner" src="/img/common/img_banner.png" /></Link>
            </ToggleDisplay>
          </div>
          <Footer/>
        </div>
      </div>
    </div>
  </div>
  )
}

}



// WEBPACK FOOTER //
// ./src/demo.js